import type { StatusTarefa } from "@escalando/contracts";
import { useCallback, useEffect, useState } from "react";
import { ErroApi } from "./api";

const fmt = new Intl.DateTimeFormat("pt-BR", { timeZone: "America/Sao_Paulo", dateStyle: "short", timeStyle: "short" });
export const dataHora = (iso?: string) => (iso ? fmt.format(new Date(iso)) : "—");

export const STATUS: Record<StatusTarefa, string> = {
  DRAFT: "rascunho", READY: "na fila", CLAIMED: "reservada", RUNNING: "executando", WAITING_APPROVAL: "aguardando aprovação",
  WAITING_INPUT: "aguardando resposta", WAITING_DEPENDENCY: "aguardando dependência", PAUSED: "pausada", DONE: "concluída",
  FAILED: "falhou", BLOCKED: "bloqueada", CANCELLED: "cancelada",
};

export const Situacao = ({ s }: { s: StatusTarefa }) => <span className={`etiqueta ${s}`}>{STATUS[s]}</span>;

/** Carrega dados da API com estado de carregamento/erro e função para recarregar. */
export function useDados<T>(carregar: () => Promise<T>, deps: unknown[] = []) {
  const [dados, setDados] = useState<T>();
  const [erro, setErro] = useState<string>();
  const recarregar = useCallback(() => {
    setErro(undefined);
    carregar().then(setDados, (e: unknown) => setErro(e instanceof ErroApi ? e.message : "falha ao carregar"));
  }, deps);
  useEffect(recarregar, [recarregar]);
  return { dados, erro, recarregar };
}

export const Carregando = ({ erro }: { erro?: string | undefined }) => (erro ? <p className="erro">{erro}</p> : <p className="suave">Carregando…</p>);
